module.exports = __webpack_public_path__ + "img/9788974840198.adbc1bb0.jpg";